import React from 'react';
import scrollIntoView from 'smooth-scroll-into-view-if-needed';
import { separatorString, id as itemId } from './constants';
import { dataKeyAttribute, dataIndexAttribute } from './constants';
export const getNodesFromRefs = (refs) => {
    const result = Object.values(refs)
        .map((el) => el.current)
        .filter(Boolean);
    return result;
};
export function observerEntriesToItems(entries, options) {
    return [...entries].map((entry) => {
        var _a, _b, _c, _d;
        const target = entry.target;
        const key = String((_b = (_a = target === null || target === void 0 ? void 0 : target.dataset) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : '');
        const index = String((_d = (_c = target === null || target === void 0 ? void 0 : target.dataset) === null || _c === void 0 ? void 0 : _c.index) !== null && _d !== void 0 ? _d : '');
        return [
            key,
            {
                index,
                key,
                entry,
                visible: entry.intersectionRatio >= options.ratio,
            },
        ];
    });
}
function scrollToItem(item, behavior, inline, block, rest, noPolyfill) {
    var _a;
    const _item = ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.target) || item;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _behavior = behavior || 'smooth';
    if (_item) {
        if (noPolyfill) {
            return _item === null || _item === void 0 ? void 0 : _item.scrollIntoView({
                behavior: _behavior,
                inline: inline || 'end',
                block: block || 'nearest',
            });
        }
        return scrollIntoView(_item, Object.assign({ behavior: _behavior, inline: inline || 'end', block: block || 'nearest', duration: 500 }, rest));
    }
}
export { scrollToItem };
export const getItemElementById = (id) => document.querySelector(`[${dataKeyAttribute}='${id}']`);
export const getItemElementByIndex = (id) => document.querySelector(`[${dataIndexAttribute}='${id}']`);
export function getElementOrConstructor(Elem) {
    return ((React.isValidElement(Elem) && Elem) ||
        (typeof Elem === 'function' && React.createElement(Elem, null)) ||
        null);
}
export const filterSeparators = (items) => items.filter((item) => !new RegExp(`.*${separatorString}$`).test(item));
export const getItemId = (item) => {
    var _a;
    return String(((_a = item === null || item === void 0 ? void 0 : item.props) === null || _a === void 0 ? void 0 : _a[itemId]) ||
        String((item === null || item === void 0 ? void 0 : item.key) || '').replace(/^\.\$/, ''));
};
